var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2e91aa375a9b77073ee73009421597042248f72a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["mubazar-frontend@mubazar"]={id:"2e91aa375a9b77073ee73009421597042248f72a"};
      